var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorDetails(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_20564_166515)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.5 3H2.5C2.23478 3 1.98043 3.10536 1.79289 3.29289C1.60536 3.48043 1.5 3.73478 1.5 4V14C1.5 14.2652 1.60536 14.5196 1.79289 14.7071C1.98043 14.8946 2.23478 15 2.5 15H16.5C16.7652 15 17.0196 14.8946 17.2071 14.7071C17.3946 14.5196 17.5 14.2652 17.5 14V4C17.5 3.73478 17.3946 3.48043 17.2071 3.29289C17.0196 3.10536 16.7652 3 16.5 3ZM16.5 14H2.5V4H16.5V14Z",
    fill: "#FF0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 7H14C14.1326 7 14.2598 6.94732 14.3536 6.85355C14.4473 6.75979 14.5 6.63261 14.5 6.5C14.5 6.36739 14.4473 6.24021 14.3536 6.14645C14.2598 6.05268 14.1326 6 14 6H5C4.86739 6 4.74021 6.05268 4.64645 6.14645C4.55268 6.24021 4.5 6.36739 4.5 6.5C4.5 6.63261 4.55268 6.75979 4.64645 6.85355C4.74021 6.94732 4.86739 7 5 7Z",
    fill: "#FF0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 9H14C14.1326 9 14.2598 8.94732 14.3536 8.85355C14.4473 8.75979 14.5 8.63261 14.5 8.5C14.5 8.36739 14.4473 8.24021 14.3536 8.14645C14.2598 8.05268 14.1326 8 14 8H5C4.86739 8 4.74021 8.05268 4.64645 8.14645C4.55268 8.24021 4.5 8.36739 4.5 8.5C4.5 8.63261 4.55268 8.75979 4.64645 8.85355C4.74021 8.94732 4.86739 9 5 9Z",
    fill: "#FF0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.58333 11H11.4167C11.5714 11 11.7197 10.9473 11.8291 10.8536C11.9385 10.7598 12 10.6326 12 10.5C12 10.3674 11.9385 10.2402 11.8291 10.1464C11.7197 10.0527 11.5714 10 11.4167 10H5.58333C5.42862 10 5.28025 10.0527 5.17085 10.1464C5.06146 10.2402 5 10.3674 5 10.5C5 10.6326 5.06146 10.7598 5.17085 10.8536C5.28025 10.9473 5.42862 11 5.58333 11Z",
    fill: "#FF0000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_20564_166515"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorDetails);
export default __webpack_public_path__ + "static/media/errorDetails.13f6f976aba836e31bbe168e95ce5d3d.svg";
export { ForwardRef as ReactComponent };